import $ from 'jquery';

class Tables {
  constructor() {
    this.table = $('table');

    this.addWrapper();
  }

  addWrapper() {
    if (!this.table.length) {
      return;
    }

    $.each(this.table, (i, el) => {
      const table = $(el);

      table.wrap('<div class="c-table__wrapper"></div>');
    });
  }
}

export default Tables;



// WEBPACK FOOTER //
// ./src/scripts/modules/tables.js